import ReactGA from 'react-ga4';

type EventAnalyticParameters = {
  action: string;
  category: string;
  label?: string;
};

type PageviewAnalyticParameters = {
  page?: string;
};

const logEventAnalytic = (gaEventParameters: EventAnalyticParameters) => {
  const { action, category, label } = gaEventParameters;
  ReactGA.event({
    category,
    action,
    label,
  });
};

const logPageviewAnalytic = (
  gaPageviewParameters: PageviewAnalyticParameters
) => {
  const { page } = gaPageviewParameters;
  ReactGA.send({
    hitType: 'pageview',
    page,
  });
};

export { logEventAnalytic, logPageviewAnalytic };
